<div class="flex flex-col ml-60 pb-20">
  <div class="flex flex-row justify-between top-header">
    <h2 class="mat-headline-5 mt-20 ml-10 mb-0">{{'LEFT_SIDE_NAV.SOLUTIONS' | transloco}}</h2>
    <div class="flex flex-row justify-center items-center mt-20">
      <div class="flex flex-row justify-between items-center search-wrapper">
        <app-search-filter (keyup)="searchSolution($event)" [placeholder]="'SOLUTIONS.SEARCH_SOLUTION'"></app-search-filter>
      </div>
      <div>
        <button class="flex justify-center items-center context-menu-icon pl-16 pr-16" (click)="filterColumns()">
          <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
          <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
        </button>
      </div>
      <!-- <div>
        <button *ngIf="permissionsMap[Permission.ADD_SOLUTION]" type="button" class="flex justify-center items-center tenant-gradient mat-subtitle-2 fw-700 m-0 pl-16 pr-16"
          (click)="addNewSolution()" mat-button>
          <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
          {{'SOLUTIONS.ADD_NEW_SOLUTION' | transloco }}
        </button>
      </div> -->
      <div class="flex flex-row">
        <mat-icon class="mr-8 cursor-pointer view-option" [ngClass]="{'selected-icon': viewSelected==='grid'}" svgIcon="grid_view" (click)="viewSelected='grid'"></mat-icon>
        <mat-icon class="mr-8 cursor-pointer view-option" [ngClass]="{'selected-icon': viewSelected==='list'}" svgIcon="format_list_bulleted" (click)="viewSelected='list'"></mat-icon>
      </div>
    </div>
  </div>
  
  <div class="flex flex-row flex-wrap justify-start items-center pt-10 pl-24 pr-24 pb-10">
    <ng-container *ngIf="selectedLineOfBusiness">
      <span>{{ 'INSTANCE_STATUS.lineOfBusiness' | transloco }}: </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{selectedLineOfBusiness}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm cursor-pointer" (click)="closeMenu(selectedLineOfBusiness)"></mat-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="selectedCategory">
      <span>{{ 'INSTANCE_STATUS.category' | transloco }}: </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{selectedCategory}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm cursor-pointer" (click)="closeMenu(selectedCategory)"></mat-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="selectedRegion">
      <span>{{ 'INSTANCE_STATUS.region' | transloco | titlecase }}: </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{selectedRegion}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm cursor-pointer" (click)="closeMenu(selectedRegion)"></mat-icon>
      </span>
    </ng-container>
    <ng-container *ngIf="selectedTenant">
      <span>{{ 'INSTANCE_STATUS.tenant' | transloco | titlecase }}: </span>
      <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
        {{selectedTenant}}
        <mat-icon svgIcon="close" class="ml-6 icon-sm cursor-pointer" (click)="closeMenu(selectedTenant)"></mat-icon>
      </span>
    </ng-container>
    <span *ngIf="selectedLineOfBusiness || selectedCategory || selectedRegion || selectedTenant" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
      (click)="resetFilter()">
      {{ 'BUTTONS.CLEAR_ALL' | transloco }}
    </span>
  </div>
  
  <div *ngIf="!showSpinner && !isFailed && viewSelected==='grid'" class="flex flex-row solutions-container pl-8 pr-8">
    <ng-container *ngFor="let solution of solutionsPage">
      <div class="solution-tile p-12 mr-24 mb-24">
        <div class="flex flex-row justify-between">
          <div class="mat-headline-5 solution-names" [title]="solution.name">{{solution.name}}</div>
          <!-- <button class="flex context-menu-icon pl-6 pr-6"
            [matMenuTriggerFor]="instanceSubmenu">
            <mat-icon svgIcon="more_vert"></mat-icon>
          </button>
          <mat-menu #instanceSubmenu [xPosition]="'before'" class="context-menu-dropdown">
            <div class="flex flex-col">
              <button class="menu-button" (click)="editSolution(solution)"
                [ngClass]="{'disable' :!permissionsMap[Permission.EDIT_SOLUTION]}">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="edit" class="icon-md"></mat-icon>
                  <div class="mat-body-1 fw-400">{{'SOLUTIONS.EDIT' | transloco }}</div>
                </div>
              </button>
              <button class="menu-button" (click)="deleteSolution(solution)"
                [ngClass]="{'disable' :!permissionsMap[Permission.DELETE_SOLUTION]}">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="delete" class="icon-md"></mat-icon>
                  <div class="mat-body-1 fw-400">{{'SOLUTIONS.DELETE' | transloco }}</div>
                </div>
              </button>
            </div>
          </mat-menu> -->
        </div>
        <div class="tag-line fs-15">{{solution?.tagline}}</div>
        <div class="fs-14 pt-12"><span class="fw-600">{{'SOLUTIONS.CREATED_ON' | transloco }}: </span>
          <span class="metrics">{{dateTimeFormatService.getUtcFromat(solution?.dateCreated)}}</span></div>
        <div class="flex flex-row items-center pt-12">
          <div class="flex flex-row justify-center items-center pr-8 divider-line">
            <div class="flex flex-row justify-center items-center done-status mr-8">
              <mat-icon svgIcon="done" class="icon-sm"></mat-icon>
            </div>
            <span class="fs-14 metrics">{{solution?.status | titlecase}}</span>
          </div>
          <div class="flex flex-row justify-center items-center pl-8" [ngClass]="{'divider-line pr-8': solution?.tenantId}">
            <mat-icon svgIcon="cloud" class="icon-md mr-8 metrics"></mat-icon>
            <span class="fs-14 metrics">{{solution?.category}}</span>
          </div>
          <div class="flex flex-row justify-center items-center pl-8">
            <span class="fs-14 metrics tenant-name" [title]="solution?.tenantId">{{solution?.tenantId | titlecase}}</span>
          </div>
        </div>
        <mat-divider class="mb-16 mt-16 neutral-2"></mat-divider>
        <div class="flex flex-row justify-between">
          <div class="mat-subtitle-2 fs-14 pl-14 pr-14 pb-4 pt-4 cursor-pointer view-versions" [routerLink]="['/', tenant, RouterSegments.TENANT, tenantId, RouterSegments.SOLUTION, solution.id, RouterSegments.EXTERNAL_PACKAGE]"
            (click)="viewExternalPackage(solution)">
            {{'SOLUTIONS.VIEW_CUSTOM_PACKAGES' | transloco }}
          </div>
          <div class="mat-subtitle-2 fs-14 pl-14 pr-14 pb-4 pt-4 cursor-pointer view-versions" [routerLink]="['/', tenant, RouterSegments.TENANT, tenantId, RouterSegments.SOLUTION, solution.id, RouterSegments.VERSIONS]"
            (click)="viewBuildVersions(solution)">
            {{'SOLUTIONS.VIEW_BUILD_VERSIONS' | transloco }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  
  <div *ngIf="!showSpinner && !isFailed && viewSelected==='list'" class="flex flex-row solutions-container pt-16">
    <ng-container *ngFor="let solution of solutionsPage">
      <div class="flex flex-row justify-between items-center w-100-percent solution-grid p-24 mb-8 ml-24 mr-24">
        <div class="flex flex-row justify-start items-center mat-headline-6 m-0 solution-name"><div class="solution-icon mr-16"></div>{{solution.name}}</div>
        <div class="category">
          <div class="flex flex-row justify-start items-center pl-8 pr-8 pt-4 pb-4 category-text">
            <mat-icon svgIcon="cloud" class="icon-md mr-8"></mat-icon>
            {{solution?.category}}
          </div>
        </div>
        <div class="created-on"><span class="fw-700">{{'SOLUTIONS.CREATED_ON' | transloco }}: </span>
          {{dateTimeFormatService.getUtcFromat(solution?.dateCreated)}}</div>
        <div class="flex flex-row justify-start items-center pr-8 status">
          <div class="flex flex-row justify-center items-center done-status mr-8"><mat-icon svgIcon="done" class="icon-sm"></mat-icon></div>
          {{solution?.status}}
        </div>
        <div class="mat-subtitle-2 m-0 cursor-pointer view-versions pt-4 pb-4 pl-10 pr-10" [routerLink]="['/', tenant, RouterSegments.TENANT, tenantId, RouterSegments.SOLUTION, solution.id, RouterSegments.VERSIONS]" (click)="viewBuildVersions(solution)">
          {{'SOLUTIONS.VIEW_BUILD_VERSIONS' | transloco }}
        </div>
      </div>
    </ng-container>
  </div>
 <div class="flex flex-row flex-wrap" *ngIf="showSpinner">
  <ng-container *ngFor="let item of [1,2,3,4]">
    <div class="solution-tile p-16 m-12 cursor-pointer">
      <div class="flex flex-row justify-between">
        <ngx-skeleton-loader class="pr-30" count="1" appearance="line"></ngx-skeleton-loader>
      </div>
      <ngx-skeleton-loader class="pr-30" count="1" appearance="line"></ngx-skeleton-loader>
      <div class="flex flex-col pt-12">
        <ngx-skeleton-loader class="loader-line pr-30" count="2" appearance="line"></ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>
</div>
  <div *ngIf="solutions?.length === 0 && !showSpinner && !isFailed" class="no-data flex justify-center w-100-percent mt-100 fs-20">
    <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10 mt-6 fw-600"> {{'SOLUTIONS.NO_SOLUTIONS_MESSAGE' | transloco }}</div>
  </div>
  <div *ngIf="isFailed" class="flex justify-center top-panel m-24 p-50">
    {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
  </div>
  
  <div *ngIf="!showSpinner && !isFailed && solutions?.length > 0" class="top-panel ml-10 mr-24 mt-10 p-20">
    <app-paginator [length]="solutions?.length" [pageSizeOptions]="[10, 15, 20]"
      [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
  </div>
</div>
